import { gql } from '@yi/core';

import { convertSubscriptionOffetToMembershipPlan } from '~/src/common/membership';
import { getQueryString } from '~/src/common/utilities';
import { useLocale } from '~/src/components/LocaleProvider';

import { getSignupUrl } from './getSignupUrl';

export function useSignupUrlBySubscriptionOffer(offer: gql.typesClient.SubscriptionOffer) {
  const { locale } = useLocale();
  const planInfo = convertSubscriptionOffetToMembershipPlan(offer);

  const href = `${getSignupUrl(locale, planInfo)}/${getQueryString()}`;
  return { href };
}
